// extracted by mini-css-extract-plugin
export var standaloneTable = "_dz-0";
export var standaloneTableWithBodyFill = "_dz-1";
export var withExtraHeader = "_dz-2";